import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import useGridConfiguration from '@/composables/useGridConfiguration'
import useFiles from '@/composables/documents/useFiles'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'
import Grid from '@/components/grids/LfGrid/LfGridComponent.vue'
import {
  ActionName,
  CommandClickEventArgs,
  CommandModel,
  commandButtonType
} from '@/components/grids/LfGrid/LfGridTypes'
import { ContextMenuItemModel, RecordClickEventArgs } from '@syncfusion/ej2-vue-grids'
import { Icons } from '@/icons/icons'
import { ListNames } from '@/store/modules/configuration/configurationTypes'
import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'

// DEFINE PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchIARelatedDocumentsComponent',
  props: {
    results: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  results: any
};



// TRANSLATIONS
const { t } = useI18n()

const TEXT = {
  relatedDocuments: t('views.search_ia_result.relatedDocuments') as string,
  openWindow: t('components.context_menu.open_window') as string
}

const ICON = {
  openWindow: Icons.OPEN_WINDOW
}

// STORE
const searchIAStore = useSearchIAStore()

// CONSTANTS
const LIST_NAME = ListNames.RELATED_DOCUMENTS

// COMPUTED
const commands = computed((): CommandModel[] => [
  {
    id: ActionName.OPEN_WINDOW,
    type: commandButtonType.NONE,
    title: TEXT.openWindow,
    buttonOption: {
      iconCss: ICON.openWindow,
      cssClass: 'custombutton'
    }
  }
])

// DATA
const { openInLocation } = useFiles()
const { gridConfiguration } = useGridConfiguration({
  listName: LIST_NAME,
  context: `SearchIA_RelatedDocuments`,
  commandButtons: commands
})

// METHODS
const openDocument = (idDocument: number, idEntity: number, idEntityType: number, documentName: string): void => {
  trackEvent(TrackerEvents.AI_SEARCH_DOCUMENT_OPENED, {
    origin_open_docs_ia_results: 'result_table',
    search_id: searchIAStore.search_id
  })
  const doc = {
    id: idDocument,
    idEntity,
    idEntityType,
    initialFile: documentName
  }
  openInLocation(doc as any)
}

const onCommandClick = (args: CommandClickEventArgs) => {
  const { idDocument, idEntity, idEntityType, documentName } = args.rowData as any
  const commandColumn = args.commandColumn as ContextMenuItemModel

  if (!idDocument || ActionName.OPEN_WINDOW !== commandColumn?.id) return

  openDocument(idDocument, idEntity, idEntityType, documentName)
}

const handleRowClick = (args: RecordClickEventArgs) => {
  const { idDocument, idEntity, idEntityType, documentName } = args.rowData as any
  if (!idDocument) return

  openDocument(idDocument, idEntity, idEntityType, documentName)
}

// Observar cambios en el documento a abrir desde el store
watch(
  () => searchIAStore.documentToOpen,
  (document) => {
    if (document && document.idDocument) {
      trackEvent(TrackerEvents.AI_SEARCH_DOCUMENT_OPENED, {
        origin_open_docs_ia_results: 'reference',
        search_id: searchIAStore.search_id
      })
      openDocument(document.idDocument, document.idEntity, document.idEntityType, document.documentName)
      // Limpiar después de procesar
      searchIAStore.clearDocumentToOpen()
    }
  }
)

return { __sfc: true,props, t, TEXT, ICON, searchIAStore, LIST_NAME, commands, openInLocation, gridConfiguration, openDocument, onCommandClick, handleRowClick, Grid }
}

})